/** Rect of the letterboxed image inside a container using object-fit: contain. */
export interface ContainedImageRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

export function getContainedImageRect(
  containerWidth: number,
  containerHeight: number,
  naturalWidth: number,
  naturalHeight: number,
): ContainedImageRect {
  if (
    containerWidth <= 0 ||
    containerHeight <= 0 ||
    naturalWidth <= 0 ||
    naturalHeight <= 0
  ) {
    return { left: 0, top: 0, width: containerWidth, height: containerHeight };
  }

  const containerRatio = containerWidth / containerHeight;
  const imageRatio = naturalWidth / naturalHeight;

  if (imageRatio > containerRatio) {
    const width = containerWidth;
    const height = containerWidth / imageRatio;
    return {
      left: 0,
      top: (containerHeight - height) / 2,
      width,
      height,
    };
  }

  const height = containerHeight;
  const width = containerHeight * imageRatio;
  return {
    left: (containerWidth - width) / 2,
    top: 0,
    width,
    height,
  };
}

export function clickToImagePercent(
  clientX: number,
  clientY: number,
  containerRect: DOMRect,
  imageRect: ContainedImageRect,
): { xPercent: number; yPercent: number } | null {
  const x = clientX - containerRect.left - imageRect.left;
  const y = clientY - containerRect.top - imageRect.top;

  if (x < 0 || y < 0 || x > imageRect.width || y > imageRect.height) {
    return null;
  }

  return {
    xPercent: Number(((x / imageRect.width) * 100).toFixed(3)),
    yPercent: Number(((y / imageRect.height) * 100).toFixed(3)),
  };
}
